import { getPersonalTemplate } from 'modules/Rations/redux/modules/ration/selectors';

export default getPersonalTemplate;
